export default { sha: 'a7364a4e83456d15582fe78767cadccc9531d664', buildNumber: 'undefined' }
